module.exports = __webpack_public_path__ + "img/exclusive_banner.6712aa97.jpg";